import { useMediaQueries } from '@hooks';
import { Button } from '@mui/material';
import classnames from 'classnames';
import { motion } from 'motion/react';

export default function Header({
  label = 'Lorem Ipsum Dolor',
  title = 'Lorem Ipsum Dolor',
  description,
  className,
  children,
  centered,
  cta = null,
}) {
  const { isMobile } = useMediaQueries();
  const url =
    cta?.href ??
    cta?.externalLink ??
    cta?.file?.data?.attributes?.url;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      viewport={{ once: true }}
      className={classnames(
        className,
        'text-primary-950 text-center flex flex-col items-center',
        centered
          ? 'md:text-center'
          : 'md:items-start md:text-start',
      )}
    >
      <div className="flex items-center w-full max-w-[419px] text-primary label space-x-4">
        {(isMobile || centered) && (
          <hr className="border-primary w-full rounded border-[1.5px] " />
        )}
        <span className="max-w-max min-w-max inline-block">
          {label}
        </span>
        <hr className="border-primary w-full rounded border-[1.5px] " />
      </div>
      <div>
        <p className=" leading-none h1">{title}</p>
      </div>
      <div className="body">{description}</div>
      {children}
      {/* {cta && (
        <Button target="_blank" href={url}>
          <span className="text-lg uppercase">{cta?.label}</span>
        </Button>
      )} */}
    </motion.div>
  );
}
